import { find } from "ramda";

export default function getStructureFieldValues(sf, path) {
  const field = find((s) => s.path === path, sf ?? []) ?? {};
  return {
    path: field.path,
    name: field.name,
    sf: field.structureFields,
    selOptions: field.selOptions,
  };
}
